import { ReactElement } from 'react';
import { TagProps } from 'antd';
import { STag } from './Tag.style';

export const Tag = ({ rootClassName, ...restProps }: TagProps): ReactElement => (
  <STag rootClassName={['custom-ant-tag', rootClassName].join(' ')} {...restProps} />
);
